import { PasswordInput, type PasswordInputProps } from "@mantine/core";
import {
  mergeFormInputClassNames,
  useFormInputStyles,
} from "./hooks/useFormInputStyles";

type FormPasswordInputProps = PasswordInputProps & {
  forceErrorState?: boolean;
};

export function FormPasswordInput({
  forceErrorState = false,
  disabled = false,
  styles,
  classNames,
  error,
  ...rest
}: FormPasswordInputProps) {
  const { forwardedError, resolvedStyles } = useFormInputStyles({
    error,
    forceErrorState,
    disabled,
    overrideStyles: styles as Parameters<
      typeof useFormInputStyles
    >[0]["overrideStyles"],
  });

  return (
    <PasswordInput
      {...rest}
      disabled={disabled}
      error={forwardedError}
      styles={resolvedStyles as PasswordInputProps["styles"]}
      classNames={mergeFormInputClassNames(classNames)}
    />
  );
}
